import {nextQuestion} from "./question";
import {startTimer} from "./timer";
import {apiStart} from "./api";

const restartElement = document.querySelector('#start h1');
document.querySelector('#start button').addEventListener('click', async () => {
await document.querySelector('#start').fadeOut();
    document.querySelector('header').fadeIn('flex');
    nextQuestion();
    await document.querySelector('#questions').fadeIn('flex');
    startTimer();
    apiStart();
})

let pressTimer;

function startPress() {
    pressTimer = setTimeout(() => {
        location.href = './';
    }, 3000);
}

function cancelPress() {
    clearTimeout(pressTimer);
}

restartElement.addEventListener('mousedown', startPress);
restartElement.addEventListener('mouseup', cancelPress);
restartElement.addEventListener('touchstart', startPress);
restartElement.addEventListener('touchend', cancelPress);